"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Toolbar_1 = __importDefault(require("@material-ui/core/Toolbar"));
var Toolbar = function (props) {
    var children = props.children, classes = props.classes, disableGutters = props.disableGutters, variant = props.variant;
    return (react_1.default.createElement(Toolbar_1.default, { classes: classes, disableGutters: disableGutters, variant: variant }, children));
};
exports.default = Toolbar;
